module.exports={
	"ViewIdentifier": "Empty",

	"DefaultRenderable": "Empty-Renderable",
	"DefaultDestinationAddress": "#LIMS-Application-Container",

	"Templates": [
		{
			"Hash": "Empty-Template",
			"Template": "<!-- Empty Space -->"
		}
	],
	"Renderables": [
		{
			"RenderableHash": "Empty-Renderable",
			"TemplateHash": "Empty-Template"
		}
	]
}
